import { render, staticRenderFns } from "./createUpdateUser.vue?vue&type=template&id=4d2b4d78&scoped=true&"
import script from "./createUpdateUser.vue?vue&type=script&lang=js&"
export * from "./createUpdateUser.vue?vue&type=script&lang=js&"
import style0 from "./createUpdateUser.vue?vue&type=style&index=0&id=4d2b4d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b4d78",
  null
  
)

export default component.exports